<template>
    <div v-if="type === 'page'" class="flex">
        <a v-if="isBookmarked"
           aria-label="Bookmark this page"
           class="relative inline-flex items-center px-3 py-2 text-sm font-semibold rounded-md shadow-xs"
           href="#"
           v-on:click.prevent="removeBookmark">
            <i class="text-lg fas fa-bookmark"></i>
        </a>
        <a v-else
           aria-label="Bookmark this page"
           class="relative inline-flex items-center px-3 py-2 text-sm font-semibold rounded-md shadow-xs"
           href="#"
           v-on:click.prevent="addBookmark">
            <i class="text-lg far fa-bookmark"></i>

        </a>

    </div>
    <div v-else class="">

        <a v-if="isBookmarked"
           class="px-3 py-2 rounded-xl text-clay-800 hover:text-clay-800"
           aria-label="Remove bookmark"
           href="#"
           v-on:click.prevent="removeBookmark">
            <i class="fas fa-bookmark"></i>

        </a>

        <a v-else
           class="px-3 py-2 rounded-xl text-clay-800 hover:bg-clay-100 hover:text-clay-800"
           aria-label="Add bookmark"
           href="#"
           v-on:click.prevent="addBookmark">
            <i class="far fa-bookmark "></i>
        </a>

    </div>

</template>

<script lang="ts" setup>
// @ts-ignore
import {defineProps, onMounted, Ref, ref} from "vue";
import {store} from "@/store";
import {client} from '@/shared';
import {AddBookmark, AddBookmarkResponse, DeleteBookmark, DeleteBookmarkResponse} from "@/dtos";
import {trackEvent} from '@/shared';

const props = defineProps({
    id: String,
    type: String
});

const id: Ref<String> = ref(props.id);
let isBookmarked: Ref<Boolean> = ref(false);
let type = props.type ?? "card";

onMounted((): void => {
    if (store.saUserSession.bookmarkedItems.includes(id.value.toLowerCase())) {
        isBookmarked.value = true;
    }
});

const addBookmark = async () => {
    if (!store.saUserSession.isAuthenticated) {
        store.showLoginDialog = true;
        return;
    }
    await client.post<AddBookmarkResponse>(new AddBookmark({id: id.value}))
        .then(() => {
            isBookmarked.value = true;
            trackEvent( 'bookmark', {
                content_id: id.value,
                content_type: id.value.split('/', 1)
            });
        })
        .catch(e => {
            console.log(e);
            if (e.responseStatus.errorCode === "Forbidden") {
                store.userPromptTitle = "Oops...";
                store.userPromptContent = e.responseStatus.message;
                store.showUserPrompt = true;
                return;
            }
        });

};

const removeBookmark = async () => {
    if (!store.saUserSession.isAuthenticated) {
        store.showLoginDialog = true;
        return;
    }
    await client.delete<DeleteBookmarkResponse>(new DeleteBookmark({id: id.value}))
        .then(() => {
            isBookmarked.value = false;
        })
};
</script>